import { __extends } from "tslib";
import { RuleSeverity } from './ValidationState';
import { Utils } from '../Utils';
import NeoStrings from '../Localisation/NeoStrings';
var Rule = /** @class */ (function () {
    function Rule() {
        this.ruleId = Utils.uuidv4();
    }
    return Rule;
}());
export { Rule };
var RequiredRule = /** @class */ (function (_super) {
    __extends(RequiredRule, _super);
    function RequiredRule(errorText, allowZero) {
        if (allowZero === void 0) { allowZero = false; }
        var _this = _super.call(this) || this;
        _this.errorText = errorText;
        _this.allowZero = allowZero;
        return _this;
    }
    RequiredRule.prototype.checkRule = function (propertyInstance, context) {
        var value = propertyInstance.value;
        if (!value && !(this.allowZero && value === 0)) {
            context.addError(this.errorText.format(propertyInstance.propertyInfo.readableName));
        }
    };
    return RequiredRule;
}(Rule));
export { RequiredRule };
var StringLengthRule = /** @class */ (function (_super) {
    __extends(StringLengthRule, _super);
    function StringLengthRule(maxLength, minLength, errorText) {
        var _this = _super.call(this) || this;
        _this.maxLength = maxLength;
        _this.minLength = minLength;
        _this.errorText = errorText;
        return _this;
    }
    StringLengthRule.prototype.checkRule = function (propertyInstance, context) {
        var value = propertyInstance.value;
        var errorTextValue = this.errorText;
        if (this.minLength && (!value || value.length < this.minLength)) {
            if (!errorTextValue)
                errorTextValue = NeoStrings.validation.rules.stringLengthLessThan;
            context.addError(errorTextValue.format(propertyInstance.propertyInfo.readableName, this.minLength.toString(), this.maxLength.toString()));
        }
        else if (value && value.length > this.maxLength) {
            if (!errorTextValue)
                errorTextValue = NeoStrings.validation.rules.stringLengthMoreThan;
            context.addError(errorTextValue.format(propertyInstance.propertyInfo.readableName, this.maxLength.toString()));
        }
    };
    return StringLengthRule;
}(Rule));
export { StringLengthRule };
var EmailAddressRule = /** @class */ (function (_super) {
    __extends(EmailAddressRule, _super);
    function EmailAddressRule(errorText) {
        var _this = _super.call(this) || this;
        _this.errorText = errorText;
        return _this;
    }
    EmailAddressRule.prototype.checkRule = function (propertyInstance, context) {
        var value = propertyInstance.value;
        if (value) {
            if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
                context.addError(this.errorText.format("'" + value + "'", propertyInstance.propertyInfo.readableName));
            }
        }
    };
    return EmailAddressRule;
}(Rule));
export { EmailAddressRule };
var RegExpRule = /** @class */ (function (_super) {
    __extends(RegExpRule, _super);
    function RegExpRule(expression, errorText) {
        var _this = _super.call(this) || this;
        _this.expression = expression;
        _this.errorText = errorText;
        return _this;
    }
    RegExpRule.prototype.checkRule = function (propertyInstance, context) {
        var value = propertyInstance.value;
        if (value) {
            if (!this.expression.test(value)) {
                context.addError(this.errorText.format("'" + value + "'", propertyInstance.propertyInfo.readableName));
            }
        }
    };
    return RegExpRule;
}(Rule));
export { RegExpRule };
var CustomRule = /** @class */ (function (_super) {
    __extends(CustomRule, _super);
    function CustomRule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomRule.prototype.onProperties = function (properties) {
        this.onPropertiesCallback = properties;
        return this;
    };
    CustomRule.prototype.onModel = function () {
        this.onPropertiesCallback = function () { return []; };
        return this;
    };
    CustomRule.prototype.getDisplayProperties = function (type) {
        if (this.onPropertiesCallback) {
            var properties = this.onPropertiesCallback(type);
            if (properties instanceof Array) {
                return properties;
            }
            else {
                return [properties];
            }
        }
        else {
            return undefined;
        }
    };
    return CustomRule;
}(Rule));
export { CustomRule };
var CallbackRule = /** @class */ (function (_super) {
    __extends(CallbackRule, _super);
    function CallbackRule(validateFn) {
        var _this = _super.call(this) || this;
        _this.validateFn = validateFn;
        _this.hasBoundFunction = false;
        if (!validateFn.hasOwnProperty("prototype")) {
            _this.hasBoundFunction = true;
        }
        return _this;
    }
    CallbackRule.prototype.checkRule = function (propertyInstance, context) {
        if (this.hasBoundFunction) {
            var reboundFn = this.validateFn.bind(propertyInstance.attachedTo);
            reboundFn(context);
        }
        else {
            this.validateFn.call(propertyInstance.attachedTo, context);
        }
    };
    return CallbackRule;
}(CustomRule));
export { CallbackRule };
var ExpressionRule = /** @class */ (function (_super) {
    __extends(ExpressionRule, _super);
    function ExpressionRule(failExpression, error, severity) {
        var _this = _super.call(this) || this;
        _this.failExpression = failExpression;
        _this.error = error;
        _this.severity = severity;
        return _this;
    }
    ExpressionRule.prototype.checkRule = function (propertyInstance, context) {
        var instance = propertyInstance.attachedTo;
        if (this.failExpression(instance)) {
            var errorText = void 0;
            if (typeof this.error === "string") {
                errorText = this.error;
            }
            else {
                errorText = this.error(instance);
            }
            if (this.severity === undefined || this.severity == RuleSeverity.Error) {
                context.addError(errorText);
            }
            else if (this.severity == RuleSeverity.Warning) {
                context.addWarning(errorText);
            }
            else {
                context.addMessage(errorText);
            }
        }
    };
    return ExpressionRule;
}(CustomRule));
export { ExpressionRule };
